import React from 'react';
import MyStatefulEditor from './MyStatefulEditor';

function FormComponent({
  handleSubmit,
  inputs,
  submitLabel = 'Enviar',
  extraContent,
}) {
  return (
    <form className='form' onSubmit={handleSubmit}>
      {inputs.map((input, i) => {
        if (input.type === 'text') {
          return (
            <div key={i} className='form__group'>
              <label className='form__label' htmlFor={input.name}>
                {input.label}
              </label>
              <input
                onChange={input.handleChange}
                value={input.value}
                className='form__input'
                name={input.name}
                type='text'
              />
            </div>
          );
        } else if (input.type === 'textarea') {
          return (
            <div key={i} className='form__group'>
              <label className='form__label' htmlFor={input.name}>
                {input.label}
              </label>
              <MyStatefulEditor
                name={input.name}
                onChange={input.handleChange}
                value={input.value}
              />
              <input
                style={{ display: 'none' }}
                value={input.value}
                name={input.name}
                type='text'
              />
            </div>
          );
        } else if (input.type === 'file') {
          return (
            <div key={i} className='form__group'>
              <label className='form__label' htmlFor={input.name}>
                {input.label}
              </label>
              <input
                onChange={input.handleChange}
                value={input.value}
                className='form__inputFile'
                multiple={input.multiple}
                accept={input.accept}
                id='pictures_upload'
                name={input.name}
                type='file'
                style={{ color: 'white' }}
              />
            </div>
          );
        } else if (input.type === 'select') {
          return (
            <div key={i} className='form__group'>
              <label className='form__label' htmlFor={input.name}>
                {input.label}
              </label>
              <select
                onChange={input.handleChange}
                value={input.value}
                className='form__select'
                name={input.name}
              >
                {input.options}
              </select>
            </div>
          );
        } else if (input.type === 'checkbox') {
          return (
            <div key={i} className='form__group'>
              <label className='form__label' htmlFor={input.name}>
                {input.label}
              </label>
              <input
                onChange={input.handleChange}
                checked={input.checked}
                className='form__inputCheckbox'
                name={input.name}
                type='checkbox'
              />
            </div>
          );
        } else if (input.type === 'hidden') {
          return <input name={input.name} type='hidden' value={input.value} />;
        }
        return <></>;
      })}
      <button className='form__submitBtn' type='submit'>
        {submitLabel}
      </button>
      {extraContent}
    </form>
  );
}

export default FormComponent;
